import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { Button, Typography, TextField } from '@mui/material';
import {
  CenteredFlexBox,
  FullSizeColumn,
} from '../../../../../Components/FlexBox';
import FormTextField from '../../../../../Components/Form/FormTextField';
import Select from '../../../../../Components/Inputs/Select';
import AppointmentSummary from './AppointmentSummary';
import ScheduleFields from '../ScheduleFields';
import useScheduleFields from '../../../Utils/useScheduleFields';
import IconButton from '../../../../../Components/Button/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const AppointmentForm = function AppointmentForm({
  isOperator,
  confirmed = false, // when true shows summary
}) {
  const intl = useIntl();
  const { setValue } = useFormContext();

  const { date, setDate, timeSlot, setTimeSlot, operators } =
    useScheduleFields(isOperator);
  const [timeUnit, setTimeUnit] = useState('MINUTES');
  const [remindBefore, setRemindBefore] = useState('10');
  const [reminder, setReminder] = useState(false);

  const handleChangeTimeUnit = (value) => {
    setTimeUnit(value);
  };

  const handleChangeRemindBefore = (event) => {
    if (parseInt(event.target.value, 10) > 0 || event.target.value === '')
      setRemindBefore(event.target.value);
  };

  useEffect(() => {
    if (!reminder) {
      setValue('remindBefore', null);
      return;
    }
    const remindBeforeInMinutes = remindBefore
      ? parseInt(remindBefore, 10) * (timeUnit === 'HOURS' ? 60 : 1)
      : null;
    setValue('remindBefore', remindBeforeInMinutes);
  }, [remindBefore, timeUnit, reminder]);

  return confirmed ? (
    <AppointmentSummary />
  ) : (
    <FullSizeColumn gap="16px" sx={{ flexGrow: 1 }}>
      <ScheduleFields
        date={date}
        timeSlot={timeSlot}
        operators={operators}
        onChangeDate={setDate}
        onChangeTimeSlot={setTimeSlot}
        assigneeDefault="ALL"
      />
      {!reminder ? (
        <Button
          onClick={() => setReminder(true)}
          variant="outlined"
          size="large"
        >
          {intl.messages.ADD_REMINDER}
        </Button>
      ) : (
        <CenteredFlexBox gap="8px">
          <Typography variant="body1">{intl.messages.REMINDBEFORE}</Typography>
          <TextField
            type="number"
            value={remindBefore}
            onChange={handleChangeRemindBefore}
            slotProps={{ htmlInput: { min: 0 } }}
          />
          <Select
            defaultValue={timeUnit}
            onChange={handleChangeTimeUnit}
            options={['MINUTES', 'HOURS']}
          />
          <IconButton id="remove-reminder" onClick={() => setReminder(false)}>
            <CloseRoundedIcon />
          </IconButton>
        </CenteredFlexBox>
      )}
      <FormTextField name="notes" multiline rows={3} />
    </FullSizeColumn>
  );
};

export default AppointmentForm;
